module.exports = __webpack_public_path__ + "img/hoboreizen_logo_rgb_pos.de7d4cf4.svg";